import { Stack, Text, Title } from '@mantine/core'
import type { ComponentType } from 'react'

export default function CenteredEmptyState({
  icon: Icon,
  title,
  description,
}: {
  icon: ComponentType<{ size: number; strokeWidth: number; color: string }>
  title: string
  description: string
}) {
  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <Stack align="center" gap="md" py="xl">
        <Icon size={48} strokeWidth={1} color="var(--mantine-color-dimmed)" />
        <Title order={3} c="dimmed">{title}</Title>
        <Text c="dimmed" size="sm">{description}</Text>
      </Stack>
    </div>
  )
}
